module.exports = __webpack_public_path__ + "media/portfolio.2623dcde.mp4";